module.exports = __webpack_public_path__ + "static/media/rbahn-echtzeit.c8562fb8.svg";